module.exports = __webpack_public_path__ + "static/media/headset-hover.f8c1c8bf.svg";